<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/refunds" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head"><div><h2 class="tpp-panel__title">退款售后</h2><p class="tpp-muted">三方同意不等于退款成功。只有支付渠道成功后才显示已退款。</p></div><el-button size="small" @click="load">刷新</el-button></div>
      <el-table :data="rows" v-loading="loading" border>
        <el-table-column prop="refundId" label="退款单" min-width="150" />
        <el-table-column prop="orderId" label="订单" min-width="150" />
        <el-table-column prop="merchantRefundNo" label="商户退款号" min-width="150" />
        <el-table-column prop="refundAmountFen" label="金额（分）" width="110" />
        <el-table-column label="三方审核" width="130"><template slot-scope="scope"><el-tag size="small" :type="providerStatus(scope.row.providerStatus).type">{{ providerStatus(scope.row.providerStatus).label }}</el-tag></template></el-table-column>
        <el-table-column label="渠道状态" width="120"><template slot-scope="scope"><el-tag size="small" :type="channelStatus(scope.row.channelStatus).type">{{ channelStatus(scope.row.channelStatus).label }}</el-tag></template></el-table-column>
        <el-table-column label="退款状态" width="120"><template slot-scope="scope"><el-tag size="small" :type="refundStatus(scope.row.refundStatus).type">{{ refundStatus(scope.row.refundStatus).label }}</el-tag></template></el-table-column>
        <el-table-column prop="reason" label="原因" min-width="140" show-overflow-tooltip />
        <el-table-column prop="rejectReason" label="处理说明" min-width="140" show-overflow-tooltip />
        <el-table-column label="操作" width="90"><template slot-scope="scope"><el-button type="text" @click="openReconcile(scope.row)">核对</el-button></template></el-table-column>
      </el-table>
    </section>

    <el-dialog title="核对退款" :visible.sync="formVisible" width="520px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="退款单">{{ form.refundId }}</el-form-item>
        <el-form-item label="三方审核" prop="providerStatus">
          <el-select v-model="form.providerStatus" placeholder="请选择服务方审核结果" style="width:100%">
            <el-option v-for="item in providerOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付渠道" prop="channelStatus">
          <el-select v-model="form.channelStatus" placeholder="请选择支付渠道退款结果" style="width:100%">
            <el-option v-for="item in channelOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <div class="tpp-tip">渠道未确认到账前不要选择“渠道退款成功”。</div>
        </el-form-item>
        <el-form-item label="处理说明"><el-input v-model.trim="form.note" type="textarea" :rows="3" maxlength="200" show-word-limit /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="formVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="reconcile">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import { PROVIDER_STATUS_OPTIONS, CHANNEL_STATUS_OPTIONS, providerStatus, channelStatus, refundStatus } from './nearbyHousekeepingRefundStatus'
import { listNearbyHousekeepingRefunds, reconcileNearbyHousekeepingRefund } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingRefunds',
  components: { NearbyHousekeepingOpsNav },
  mixins: [nearbyHousekeepingOpsMixin],
  data() {
    return {
      loading: false, saving: false, rows: [], formVisible: false,
      providerOptions: PROVIDER_STATUS_OPTIONS, channelOptions: CHANNEL_STATUS_OPTIONS,
      form: { refundId: '', providerStatus: '', channelStatus: '', note: '' },
      rules: { providerStatus: [{ required: true, message: '请选择三方审核结果' }], channelStatus: [{ required: true, message: '请选择支付渠道状态' }] }
    }
  },
  async created() { if (await this.ensureNearbyHousekeepingPlatform()) this.load() },
  methods: {
    providerStatus, channelStatus, refundStatus,
    async load() { this.loading = true; try { this.rows = (await listNearbyHousekeepingRefunds({ platformId: this.platformId, page: 1, row: 100 })).data || [] } catch (e) { this.$message.error(e.message || '退款列表加载失败') } finally { this.loading = false } },
    openReconcile(row) {
      const known = (options, value) => options.some(item => item.value === value) ? value : ''
      this.form = { refundId: row.refundId, providerStatus: known(PROVIDER_STATUS_OPTIONS, row.providerStatus), channelStatus: known(CHANNEL_STATUS_OPTIONS, row.channelStatus), note: row.rejectReason || '' }
      this.formVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    async reconcile() {
      if (this.saving) return
      try { await this.$refs.form.validate() } catch (e) { return }
      this.saving = true
      try {
        await reconcileNearbyHousekeepingRefund({ platformId: this.platformId, ...this.form })
        this.formVisible = false
        this.$message.success('退款状态已更新')
        this.load()
      } catch (e) { this.$message.error(e.message || '核对失败') } finally { this.saving = false }
    }
  }
}
</script>
